module.exports = __webpack_public_path__ + "img/btn_top.0c3d03b6.png";